import React from 'react'
import { Modal, Backdrop, Fade, Box, useTheme } from '@material-ui/core'
import Picker from '@emoji-mart/react'
import data from '@emoji-mart/data/sets/15/google.json'
import { useStyles } from './style'

const EmojiOptions = props => {
  const {
    children,
    disabled,
    handleAddEmoji,
    showEmoji,
    setShowEmoji,
    position = 'center' // 'center' ou 'floating'
  } = props

  const classes = useStyles()
  const theme = useTheme()

  const handleClose = () => setShowEmoji(false)

  return (
    <>
      <div
        onClick={() => !disabled && setShowEmoji(!showEmoji)}
        style={{ display: 'inline-block' }}
      >
        {children}
      </div>

      <Modal
        open={showEmoji}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        // No modo floating, podemos deixar o fundo transparente para não perder o foco do menu
        BackdropProps={{
          timeout: 500,
          style: {
            backgroundColor:
              position === 'floating' ? 'transparent' : 'rgba(0,0,0,0.5)'
          }
        }}
        // Aqui está o segredo: mudamos o alinhamento do Modal
        className={
          position === 'floating' ? classes.modalFloating : classes.modalCenter
        }
      >
        <Fade in={showEmoji}>
          <Box className={classes.pickerContainer}>
            <Picker
              data={data}
              set="google"
              locale="pt"
              onEmojiSelect={e => {
                handleAddEmoji(e)
                handleClose()
              }}
              theme={theme.palette.type === 'dark' ? 'dark' : 'light'}
              previewPosition="none"
              skinTonePosition="none"
            />
          </Box>
        </Fade>
      </Modal>
    </>
  )
}

export default EmojiOptions
